(() => {
  const countryToCurrency = {
    CA: 'CAD',
    AU: 'AUD',
    JP: 'JPY',
    SG: 'SGD',
    TR: 'TRY',
    RU: 'RUB',
    KZ: 'KZT',
    UZ: 'UZS',
    KG: 'KGS',
    TJ: 'TJS',
    TM: 'TMT',
    FR: 'EUR',
    IT: 'EUR',
    DE: 'EUR',
    GB: 'GBP',
    CH: 'CHF',
    CN: 'CNY'
  };

  const country = (document.documentElement.dataset.heCountry || window.Shopify?.country || '').toUpperCase();
  const targetCurrency = countryToCurrency[country];

  if (!targetCurrency || targetCurrency === 'USD') return;

  const cacheKey = 'he_fx_usd_rates_v1';
  const cacheMaxAge = 24 * 60 * 60 * 1000;
  let activeRate = null;
  let renderQueued = false;

  function formatLocal(amount) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: targetCurrency,
        maximumFractionDigits: targetCurrency === 'JPY' ? 0 : 2
      }).format(amount);
    } catch (_) {
      return amount.toFixed(targetCurrency === 'JPY' ? 0 : 2) + ' ' + targetCurrency;
    }
  }

  function renderPrices() {
    if (!activeRate) return;
    document.querySelectorAll('[data-he-base-cents]').forEach((node) => {
      const cents = Number(node.dataset.heBaseCents);
      if (!Number.isFinite(cents)) return;
      const localAmount = (cents / 100) * activeRate;
      node.textContent = '≈ ' + formatLocal(localAmount) + ' ' + targetCurrency;
      node.title = 'Estimated local price. Checkout currency remains USD.';
      node.hidden = false;
    });
    addAttribution();
  }

  function queueRender() {
    if (renderQueued) return;
    renderQueued = true;
    requestAnimationFrame(() => {
      renderQueued = false;
      renderPrices();
    });
  }

  function addAttribution() {
    if (document.querySelector('.he-fx-attribution')) return;
    const footer = document.querySelector('footer, #footer-group');
    if (!footer) return;
    const link = document.createElement('a');
    link.className = 'he-fx-attribution';
    link.href = 'https://www.exchangerate-api.com';
    link.target = '_blank';
    link.rel = 'nofollow noopener';
    link.textContent = 'Rates by ExchangeRate-API';
    footer.appendChild(link);
  }

  async function getRate() {
    try {
      const cached = JSON.parse(localStorage.getItem(cacheKey) || 'null');
      if (cached && Date.now() - cached.savedAt < cacheMaxAge && cached.rates?.[targetCurrency]) {
        return Number(cached.rates[targetCurrency]);
      }
    } catch (_) {}

    const response = await fetch('https://open.er-api.com/v6/latest/USD', {
      method: 'GET',
      mode: 'cors',
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('FX request failed');

    const data = await response.json();
    if (data.result !== 'success' || !data.rates?.[targetCurrency]) {
      throw new Error('FX rate unavailable');
    }

    try {
      localStorage.setItem(cacheKey, JSON.stringify({ savedAt: Date.now(), rates: data.rates }));
    } catch (_) {}

    return Number(data.rates[targetCurrency]);
  }

  getRate()
    .then((rate) => {
      if (!Number.isFinite(rate) || rate <= 0) return;
      activeRate = rate;
      renderPrices();

      const observer = new MutationObserver(queueRender);
      observer.observe(document.body, { childList: true, subtree: true });
    })
    .catch(() => {
      // Fail safely: keep original USD prices only.
    });
})();